import React, { useEffect, useState } from "react";
import { Tabs, Tab, Nav } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import "./Exchange.scss";
import "../../components/common/MobileTabs/MobileTabs.scss";
import ResponsiveExchange from "./ResponsiveLayout.jsx";
import { saveMobileTab, saveChangesGridLayout, saveChangesGridList, saveCurrentWorkspace, getUserLayout } from "../../features/persist/persistSlice";
import { SocketHook } from "../../hooks/socketHook";
import { useExchangeRoomSync } from "../../hooks/useExchangeRoomSync";
import useTradeBalanceSync from "../../hooks/useTradeBalanceSync";
import { parseJSON } from "../../helpers/commonHelper";
import { DEFAULT_EMPTY_LAYOUT, DEFAULT_LAYOUT, LAYOUT_LIST, normalizeTradeGridLayout } from "../../constants/grid.layout";
import { CloseIcon, ListIcon, PlusIcon } from "../../assets/Svg/SvgImages.jsx";
const Exchange = () => {
  // const grid_layout = useSelector((state) => state.persist);
  const socketHook = SocketHook();
  useExchangeRoomSync();
  useTradeBalanceSync();
  const dispatch = useDispatch();
  const [isActive, setActive] = useState(true);
  const mobile_tab = useSelector(state => state.persist.mobile_tab);
  const layoutList = useSelector(state => state.persist.layoutList);
  const current_workspace = useSelector(state => state.persist.current_workspace);
  const current_breakpoint = useSelector(state => state.persist.current_breakpoint);
  // console.log("grid_layout", grid_layout)
  const gridLayout = useSelector(state => state.persist.grid_layout);
  const handleMobileTab = type => {
    dispatch(saveMobileTab(type));
    // console.log('Testing Lg -> ', gridLayout);
    let lgGrid = gridLayout?.lg;
    let mdGrid = gridLayout?.md;
    let newLaout = {
      lg: lgGrid,
      md: mdGrid
    };
    let mobGrid = [{
      i: "TradeChart",
      x: 0,
      y: 0,
      h: 11.2,
      w: 30,
      isResizable: false,
      isDraggable: false
    }, {
      i: "OpenOrder",
      x: 0,
      y: 0,
      h: 12,
      w: 30,
      isResizable: false,
      isDraggable: false
    }];
    switch (type) {
      case "TRADE":
        let smMobGridTrade = [{
          i: "TradeChart",
          x: 0,
          y: 0,
          h: 13.5,
          w: 30,
          isResizable: false,
          isDraggable: false
        }, {
          i: "OpenOrder",
          x: 0,
          y: 0,
          h: 17.5,
          w: 30,
          isResizable: false,
          isDraggable: false
        }];
        mobGrid = [{
          i: "TradeChart",
          x: 0,
          y: 0,
          h: 11.2,
          w: 30,
          isResizable: false,
          isDraggable: false
        }, {
          i: "OpenOrder",
          x: 0,
          y: 0,
          h: 12,
          w: 30,
          isResizable: false,
          isDraggable: false
        }];
        newLaout.sm = smMobGridTrade;
        newLaout.xs = mobGrid;
        dispatch(saveChangesGridLayout(newLaout));
        break;
      case "BUYSELL":
        let smMobGrid = [{
          i: "BuySellTab",
          x: 0,
          y: 0,
          h: 16.8,
          w: 30,
          isResizable: false,
          isDraggable: false
        }, {
          i: "Accounts",
          x: 0,
          y: 0,
          h: 14,
          w: 30,
          isResizable: false,
          isDraggable: false
        }];
        mobGrid = [{
          i: "BuySellTab",
          x: 0,
          y: 0,
          h: 16.8,
          w: 30,
          isResizable: false,
          isDraggable: false
        }, {
          i: "Accounts",
          x: 0,
          y: 0,
          h: 8.5,
          w: 30,
          isResizable: false,
          isDraggable: false
        }];
        newLaout.sm = smMobGrid;
        newLaout.xs = mobGrid;
        dispatch(saveChangesGridLayout(newLaout));
        break;
      case "BOOK":
        let smMobGridBook = [{
          i: "OrderBook",
          x: 0,
          y: 0,
          h: 27.6,
          w: 30,
          isResizable: false,
          isDraggable: false
        }];
        mobGrid = [{
          i: "OrderBook",
          x: 0,
          y: 0,
          h: 18.2,
          w: 30,
          isResizable: false,
          isDraggable: false
        }];
        newLaout.sm = smMobGridBook;
        newLaout.xs = mobGrid;
        dispatch(saveChangesGridLayout(newLaout));
        break;
      case "MARKET":
        let smMobGridMarket = [{
          i: "WatchList",
          x: 0,
          y: 0,
          h: 17.9,
          w: 30,
          isResizable: false,
          isDraggable: false
        }, {
          i: "MarketTrades",
          x: 0,
          y: 15,
          h: 13.1,
          w: 30,
          isResizable: false,
          isDraggable: false
        }];
        mobGrid = [{
          i: "WatchList",
          x: 0,
          y: 0,
          h: 12.2,
          w: 30,
          isResizable: false,
          isDraggable: false
        }, {
          i: "MarketTrades",
          x: 0,
          y: 15,
          h: 10,
          w: 30,
          isResizable: false,
          isDraggable: false
        }];
        newLaout.sm = smMobGridMarket;
        newLaout.xs = mobGrid;
        dispatch(saveChangesGridLayout(newLaout));
        break;
      default:
        newLaout.sm = mobGrid;
        newLaout.xs = mobGrid;
        dispatch(saveChangesGridLayout(newLaout));
        break;
    }
  };
  const onWorkspaceChange = async key => {
    const layouts = parseJSON(layoutList);
    layouts.forEach(ele => {
      ele.active = false;
    });
    const newGridIndex = layouts.findIndex(ele => {
      if (ele.workspace.replace(/ /g, '_') === key.replace(/ /g, '_')) {
        return ele;
      }
    });
    layouts[newGridIndex].active = true;
    dispatch(saveCurrentWorkspace(layouts[newGridIndex].workspace.replace(/ /g, '_')));
    dispatch(saveChangesGridLayout(parseJSON(layouts[newGridIndex].layout)));
    dispatch(saveChangesGridList(parseJSON(layouts))); // Update Redux state
  };
  const parseWorkspaceRenameParts = workspace => {
    // "Workspace 2" => { suffix: "" }
    // "Workspace 2-copy" => { suffix: "-copy" }
    const match = String(workspace ?? '').match(/^Workspace\s+(\d+)(.*)$/);
    if (!match) return null;
    return {
      number: Number(match[1]),
      suffix: match[2] ?? ''
    };
  };
  const renumberWorkspacesSequentially = workspaceList => {
    return workspaceList.map((w, idx) => {
      const parts = parseWorkspaceRenameParts(w?.workspace);
      const suffix = parts ? parts.suffix : '';
      return {
        ...w,
        workspace: `Workspace ${idx + 1}${suffix}`
      };
    });
  };
  const onAddNewWorkspace = async () => {
    const layouts = parseJSON(layoutList);
    layouts.forEach(ele => ele.active = false);
    const nameNumber = layouts.reduce((max, ele) => {
      const parts = parseWorkspaceRenameParts(ele?.workspace);
      const n = parts?.number;
      return Number.isFinite(n) ? Math.max(max, n) : max;
    }, 0);
    const newLayout = {
      workspace: `Workspace ${nameNumber + 1}`,
      disable: false,
      active: true,
      layout: DEFAULT_EMPTY_LAYOUT
    };
    layouts.push(newLayout);
    dispatch(saveCurrentWorkspace(newLayout.workspace.replace(/ /g, '_')));
    dispatch(saveChangesGridLayout(parseJSON(newLayout.layout)));
    dispatch(saveChangesGridList(parseJSON(layouts))); // Update Redux state
    await updateLayout(layouts, 4);
  };
  const onRemoveWorkspace = async index => {
    const layouts = parseJSON(layoutList);
    layouts.splice(index > 0 ? index : 0, 1);
    const filterdList = parseJSON(layouts);
    if (!filterdList.length) {
      dispatch(saveCurrentWorkspace(''));
      dispatch(saveChangesGridLayout({}));
      dispatch(saveChangesGridList([])); // Update Redux state
      await updateLayout([], 3);
    } else {
      const activeIdx = index >= filterdList.length ? index - 1 : index;

      // Ensure only one active workspace after deletion.
      filterdList.forEach(ele => {
        ele.active = false;
      });
      filterdList[activeIdx].active = true;
      const renumberedList = renumberWorkspacesSequentially(filterdList);
      const activeWorkspace = renumberedList.find(ele => ele.active) ?? renumberedList[0];
      dispatch(saveCurrentWorkspace(activeWorkspace.workspace.replace(/ /g, '_')));
      dispatch(saveChangesGridLayout(parseJSON(activeWorkspace.layout)));
      dispatch(saveChangesGridList(parseJSON(renumberedList))); // Update Redux state
      await updateLayout(renumberedList, 2);
    }
    // if (index === 0) {
    // dispatch(saveCurrentWorkspace(''));
    // dispatch(saveChangesGridLayout({}));
    // dispatch(saveChangesGridList([])); // Update Redux state
    // await updateLayout([], 3);
    // } else {
    //   const layouts = parseJSON(layoutList);
    //   layouts.splice(index, 1);
    //   const filterdList = parseJSON(layouts);
    //   filterdList[index - 1].active = true;
    //   dispatch(saveCurrentWorkspace(filterdList[index - 1].workspace.replace(/ /g, '_')));
    //   dispatch(saveChangesGridLayout(parseJSON(filterdList[index - 1].layout)));
    //   dispatch(saveChangesGridList(parseJSON(filterdList))); // Update Redux state
    //   await updateLayout(filterdList, 2);
    // }
  };
  const handleDuplicate = async index => {
    const layouts = parseJSON(layoutList);
    layouts.forEach(ele => ele.active = false);
    const newLayout = {
      workspace: `${layouts[index].workspace}-copy`,
      disable: false,
      active: true,
      layout: layouts[index].layout
    };
    layouts.splice(index + 1, 0, newLayout);
    dispatch(saveCurrentWorkspace(newLayout.workspace.replace(/ /g, '_')));
    dispatch(saveChangesGridLayout(parseJSON(newLayout.layout)));
    dispatch(saveChangesGridList(parseJSON(layouts))); // Update Redux state
    await updateLayout(layouts, 1);
    setActive(!isActive);
  };
  const toggleClass = () => {
    setActive(!isActive);
  };
  const updateLayout = async (layouts, test) => {
    await getUserLayout("PUT", {
      layouts
    });
  };
  const getLayout = async () => {
    const response = await getUserLayout("GET", {});
    if (response.status === 200) {
      if (response.data && response.data.length) {
        const layouts = response.data.map(workspace => ({
          ...workspace,
          layout: normalizeTradeGridLayout(workspace.layout)
        }));
        const layout = layouts.find(o => o.active);
        dispatch(saveCurrentWorkspace(layout.workspace.replace(/ /g, '_')));
        dispatch(saveChangesGridLayout(layout.layout));
        dispatch(saveChangesGridList(layouts));
        await updateLayout(layouts);
        return;
      }
    }
    dispatch(saveChangesGridLayout(normalizeTradeGridLayout(DEFAULT_LAYOUT)));
  };
  useEffect(() => {
    getLayout();
    document.body.addEventListener('click', e => {
      if (e.target?.className?.baseVal !== 'list_icon' && e.target?.className !== 'list_icon') {
        setActive(true);
      }
    });
  }, []);
  return <>
      {/* <Header /> */}
      <div className="mainExchangelayout">
        {/* For Web view */}
        <div className="wrapperLayout">
          <Tab.Container id="left-tabs-example" onSelect={onWorkspaceChange} activeKey={current_workspace}>
            <div className="exchangeTabs d-flex align-items-center pb-2 px-3">
              <Nav variant="pills" className="btnTabs">
                {layoutList.map((item, index) => <div className="workspace_list">
                      <Nav.Item>
                        <Nav.Link eventKey={item.workspace.replace(/ /g, '_')}>
                          {item.workspace}
                        </Nav.Link>
                      </Nav.Item>
                      {item.active ? <span className="listClosebtn">
                            <button onClick={toggleClass} type="button" className="list_icon"><ListIcon /></button>
                            <button type="button" onClick={e => onRemoveWorkspace(index)}><CloseIcon /></button>
                            <div className={isActive ? 'openbtn duplicateBtn' : 'duplicateBtn'}>
                              <button onClick={() => handleDuplicate(index)} type="button">Duplicate</button>
                            </div>
                          </span> : <></>}
                    </div>)}
              </Nav>
              {layoutList.length < 18 ? <div className="plusTab ms-2">
                    <button type="button" onClick={() => onAddNewWorkspace()} className="plusBtn"><PlusIcon /></button>
                  </div> : <></>}
            </div>
            <div>
              <Tab.Content>
                {layoutList.map(item => <Tab.Pane eventKey={item.workspace.replace(/ /g, '_')}>
                      {item.active ? <ResponsiveExchange /> : <></>}
                    </Tab.Pane>)}
              </Tab.Content>
            </div>
          </Tab.Container>

          {/* <Tabs
            defaultActiveKey={current_workspace}
            id="uncontrolled-tab-example"
            className="btnTabs exchangeTabs"
            onSelect={(e) => onWorkspaceChange(e)}
           >
            {
              layoutList.map((item, index) => (
                < Tab eventKey={item.workspace.replace(/ /g, '_')} title={item.workspace} >
                  {
                    item.active ? <ResponsiveExchange /> : <></>
                  }
                </Tab>
              ))
            }
           </Tabs> */}
        </div>
        {/* Mobile View */}
        {(current_breakpoint === "sm" || current_breakpoint === "xs") && <div className="mobileTabs ">
            <ul>
              <li>
                <a to="/" onClick={() => {
              handleMobileTab("TRADE");
            }} className={mobile_tab === "TRADE" ? "active" : ""}>
                  TRADE
                </a>
              </li>
              <li>
                <a to="/" onClick={() => {
              handleMobileTab("BUYSELL");
            }} className={mobile_tab === "BUYSELL" ? "active" : ""}>
                  BUYSELL
                </a>
              </li>
              <li>
                <a to="/" onClick={() => {
              handleMobileTab("BOOK");
            }} className={mobile_tab === "BOOK" ? "active" : ""}>
                  BOOK
                </a>
              </li>
              <li>
                <a to="/" onClick={() => {
              handleMobileTab("MARKET");
            }} className={mobile_tab === "MARKET" ? "active" : ""}>
                  MARKET
                </a>
              </li>
            </ul>
          </div>}
      </div>
    </>;
};
export default Exchange;